import React from "react";
import "./Button.css";

export default function BotonDisminuir({ id, onSelect }) {
  return (
    <button
      className="btn-uix btn-disminuir"
      onClick={(e) => {
        e.stopPropagation();
        onSelect(id, "disminuir");
      }}
    >
      −
    </button>
  );
}   